<template>
    <div class="template-base" style="overflow-y:auto">
        <Header Title="" class="div-header" />        
                
        <div class="section-title" v-if="superHotkeys.length > 0"><h3>Super User Settings</h3></div>
        <hr class="section-divider" v-if="superHotkeys.length > 0" />
        <div v-if="superHotkeys.length > 0" class="section-container">
            <Button class="section-button" v-for="hotkey in superHotkeys" :key="hotkey.KeyCaption" :buttonModel="hotkey" />
        </div>
                
        <div class="section-title" v-if="appHotkeys.length > 0"><h3>Applications</h3></div>
        <hr class="section-divider" v-if="appHotkeys.length > 0" />
        <div v-if="appHotkeys.length > 0" class="section-container">
            <Button class="section-button" v-for="hotkey in appHotkeys" :key="hotkey.KeyCaption" :buttonModel="hotkey" />
        </div>
                
        <div class="section-title" v-if="systemHotkeys.length > 0"><h3>System Configuration</h3></div>
        <hr class="section-divider" v-if="systemHotkeys.length > 0" />
        <div v-if="systemHotkeys.length > 0" class="section-container">
            <Button class="section-button" v-for="hotkey in systemHotkeys" :key="hotkey.KeyCaption" :buttonModel="hotkey" />
        </div>
                
        <div class="section-title" v-if="cashierHotkeys.length > 0"><h3>Cashier Configuration</h3></div>
        <hr class="section-divider" v-if="cashierHotkeys.length > 0" />
        <div v-if="cashierHotkeys.length > 0" class="section-container">
            <Button class="section-button" v-for="hotkey in cashierHotkeys" :key="hotkey.KeyCaption" :buttonModel="hotkey" />
        </div>
                
        <div class="section-title" v-if="posHotkeys.length > 0"><h3>Point of Sale Configuration</h3></div>
        <hr class="section-divider" v-if="posHotkeys.length > 0" />
        <div v-if="posHotkeys.length > 0" class="section-container">
            <Button class="section-button" v-for="hotkey in posHotkeys" :key="hotkey.KeyCaption" :buttonModel="hotkey" />
        </div>
                
        <div class="section-title" v-if="systemTools.length > 0"><h3>System Tools</h3></div>
        <hr class="section-divider" v-if="systemTools.length > 0" />
        <div v-if="systemTools.length > 0" class="section-container">
            <Button class="section-button" v-for="hotkey in systemTools" :key="hotkey.KeyCaption" :buttonModel="hotkey" />
        </div>
                
        <div class="section-title" v-if="schedulerHotkeys.length > 0"><h3>Scheduler Configuration</h3></div>
        <hr class="section-divider" v-if="schedulerHotkeys.length > 0" />
        <div v-if="schedulerHotkeys.length > 0" class="section-container">
            <Button class="section-button" v-for="hotkey in schedulerHotkeys" :key="hotkey.KeyCaption" :buttonModel="hotkey" />
        </div>
    </div>
</template>

<script>
import ButtonModel from "@/common/models/ButtonModel";
import Button from "@/views/components/Shared/Button";
import Header from "@/views/components/Shared/Header";
import { ref } from "@vue/reactivity";
import PortalUserModel from "@/common/models/PortalUserModel";
import router from "@/router";

export default {
    components: { Button, Header },
    setup() {
        var portalUser = PortalUserModel.fromToken();

        if (isNaN(portalUser.exp)){
            router.push({ name: "Login" });
        }

        var currentDateTime = new Date().ToEpoch();
        //console.log("currentDateTime", currentDateTime);
        //console.log("portalUser.exp", portalUser.exp * 1000);
        if (currentDateTime > portalUser.exp * 1000) {
            console.log("jwt expired..");
            router.push({ name: "Login" });
        }

        const _portalUser = ref(portalUser);

        const showMe = ref(false);

        const appHotkeys = [];
        const posHotkeys = [];
        const systemTools = [];
        const schedulerHotkeys = [];
        const systemHotkeys = [];
        const cashierHotkeys = [];
        const superHotkeys = [];

        if (!portalUser.isSuperUser && !portalUser.isManager) {
            if (!portalUser.enablePos) {
                appHotkeys.push(ButtonModel.CreateRouteWithIcon("Cashier", "Cashier", "/images/icons/cashier.png"));

                if (portalUser.enableSquare)
                    appHotkeys.push(ButtonModel.CreateRouteWithIcon("Square Orders", "Square-Orders", "/images/icons/square-pos.png"));
            }
        }

        if (portalUser.enablePos) {
            appHotkeys.push(ButtonModel.CreateRouteWithIcon("Point Of Sale", "PointOfSale", "/images/icons/pos.png"));
        }

        if ((portalUser.isAdmin || portalUser.isAdminPlus) && portalUser.enablePos && portalUser.enableInventoryManagement && !portalUser.disableInventoryManagement) {
            posHotkeys.push(ButtonModel.CreateRouteWithIcon("Inventory", "Inventory", "/images/icons/inventory.png"));
            posHotkeys.push(ButtonModel.CreateRouteWithIcon("Tax Rates", "TaxRates", "/images/icons/taxrate.png"));
            posHotkeys.push(ButtonModel.CreateRouteWithIcon("Menu Groups", "Groups", "/images/icons/group.png"));
            //posHotkeys.push(ButtonModel.CreateRouteWithIcon("Discounts", "Discounts", "/images/icons/discount.png"));
        }

        if (portalUser.enableScheduler) {
            appHotkeys.push(ButtonModel.CreateRouteWithIcon("Schedule Sheet", "Schedule Sheet", "/images/icons/schedulesheet.png"));
        }

        if (portalUser.enableScheduler && (portalUser.isAdmin || portalUser.isAdminPlus)) {
            schedulerHotkeys.push(ButtonModel.CreateRouteWithIcon("Resources", "Scheduler-Resources", "/images/icons/resource.png"));
        }

        if (portalUser.isAdmin || portalUser.isAdminPlus) {
            
            if (!portalUser.disableCustomerManagement)
                appHotkeys.push(ButtonModel.CreateRouteWithIcon("Members", "Member-Management", "/images/icons/members.png"));
            
            if (!portalUser.disablePinTicket)
                appHotkeys.push(ButtonModel.CreateRouteWithIcon("Batch Pin Codes", "Batch-PinCodes", "/images/icons/pincode.png"));
            
            appHotkeys.push(ButtonModel.CreateRouteWithIcon("Reporting", "Reporting", "/images/icons/report.png"));
            
            if (!portalUser.disableUserRights)
                systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Users", "User-Management", "/images/icons/usermanagement.png"));

            if (!portalUser.disableCustomerCategory)
                systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Categories", "Category", "/images/icons/category.png"));                            

            if (!portalUser.disableHotKeys)
                systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Hotkeys", "Hotkeys", "/images/icons/hotkeys.png"));

            // If POS is not enabled then add taxes under system settings  
            if (!(portalUser.enablePos && portalUser.enableInventoryManagement))
                systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Tax Rates", "TaxRates", "/images/icons/taxrate.png"));

            // TODO:sub - Undo
            // if (!portalUser.disableCustomerCategory) {             
            //     systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Subscriptions", "Subscription-Management", "/images/icons/subscription.png"));
            // }

            if (!portalUser.disablePreferences || !portalUser.disableKiosk || !portalUser.disablePinTicket)
                systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Settings", "Settings", "/images/icons/settings.png"));

            if (portalUser.enableBays) {
                systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Bay Pricing", "BayPricing-Management", "/images/icons/golfer.png"));
            }

            if (portalUser.isAdminPlus) {
                systemTools.push(ButtonModel.CreateRouteWithIconColor("Stations", "Station-Management", "/images/icons/station.png", "#EDF3E2"));
                systemTools.push(ButtonModel.CreateRouteWithIconColor("Terminals", "Terminal-Management", "/images/icons/terminal.png", "#EDF3E2"));                
                systemTools.push(ButtonModel.CreateRouteWithIconColor("Locations", "Location-Management", "/images/icons/locations.png", "#EDF3E2"));                
                systemTools.push(ButtonModel.CreateRouteWithIconColor("Station Logs", "Station-Logs", "/images/icons/research.png", "#CBD1C0"));                
                systemTools.push(ButtonModel.CreateRouteWithIconColor("Exception Logs", "Exception-Logs", "/images/icons/exceptions.png", "#CBD1C0"));                
            }
                        
            appHotkeys.push(ButtonModel.CreateRouteWithIcon("Refunds", "Refund-Management", "/images/icons/refund.png"));            
            
        }
    
        if (portalUser.isSuperAdmin) {
            superHotkeys.push(ButtonModel.CreateRouteWithIcon("Environments", "Environment-Management", "/images/icons/environment.png"));

            systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Users", "User-Management", "/images/icons/usermanagement.png"));
        }

        if (portalUser.isSuperUser || portalUser.isManager) {
            superHotkeys.push(ButtonModel.CreateRouteWithIcon("Sites", "Tenant-Management", "/images/icons/sites.png"));
            if (!portalUser.isManager){
                systemTools.push(ButtonModel.CreateRouteWithIcon("Data Exports", "Data-Exports", "/images/icons/database-export.png"));                            
                superHotkeys.push(ButtonModel.CreateRouteWithIcon("Legacy Sites", "Tenant-Management-Legacy", "/images/icons/sites-legacy.png"));
                superHotkeys.push(ButtonModel.CreateRouteWithIcon("Vendors", "Vendor-Management", "/images/icons/vendors.png"));
                superHotkeys.push(ButtonModel.CreateRouteWithIcon("Station QRs", "Station-QR-Management", "/images/icons/qr.png"));
                superHotkeys.push(ButtonModel.CreateRouteWithIcon("Station Dashboard", "Station-Dashboard", "/images/icons/station-dashboard.png"));
                systemHotkeys.push(ButtonModel.CreateRouteWithIcon("Site Switcher", "Site-Switcher", "/images/icons/switch.png"));
                systemTools.push(ButtonModel.CreateRouteWithIcon("CardPointe Compare", "CardPointe-Compare", "/images/icons/compare.png"));
                systemTools.push(ButtonModel.CreateRouteWithIcon("MoR Dashboard", "MoR-Dashboard", "/images/icons/merchant-of-record.png"));
            }            
            
        }

        return { showMe, appHotkeys, systemHotkeys, cashierHotkeys, posHotkeys, schedulerHotkeys, superHotkeys, systemTools, _portalUser };
    }
};
</script>

<style scoped>
.section-container {
    display: flex;
    flex-wrap: wrap;    
    margin: 10px;
}

.section-button {
    margin: 10px;
    border: 3px solid gray;
    text-transform: uppercase;
    font-size: 11pt;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
}

.section-title {
    padding-left:10px;
    text-transform: uppercase;
    font-size: 10pt;
    /* color: var(--card-body-border); */
}

.section-divider {
    width:99%;
    background-color: var(--card-body-border);
    height: 2px;
}
</style>
